"use client";

import { ArrowLeft } from "lucide-react";
import Link from "next/link";
import { useUser } from "@/hooks/useUser";
import { DASHBOARD_PATH } from "@/lib/routes/enterprise-nav-paths";

/**
 * The way out of the wizard, for signed-in users only.
 *
 * `/create` has no dashboard chrome at all: no sidebar, no command palette, and
 * until this, no link back. Once in, the only exits were finishing the wizard or
 * the browser's back button, which the first reviewer hit immediately after the
 * palette's "New event" dropped her here.
 *
 * Gated on a signed-in user because the wizard is deliberately anonymous through
 * the fill (auth is only enforced at final submit, see `app/create/page.tsx`), and
 * an anonymous visitor has no dashboard to go back to. `useUser` returns a null
 * user for them, and while it resolves, so nothing flashes in and out.
 *
 * @returns The link, or null when there is no signed-in user.
 */
export const BackToDashboardLink = () => {
  // Hooks
  const { user, isLoading } = useUser();

  // Render
  if (isLoading || !user) return null;

  return (
    <Link
      href={DASHBOARD_PATH}
      className="inline-flex items-center gap-1.5 text-xs font-medium text-gray-500 transition-colors hover:text-gray-900"
    >
      <ArrowLeft className="size-3.5" aria-hidden="true" />
      Back to dashboard
    </Link>
  );
};
